// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1erZx","footer":"ModalInfo_footer__2D2L9"};